var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-wrapper",class:{'gradient-wrapper': _vm.withGradient}},[_c('responsive-image',{class:_vm.imageClasses,attrs:{"image":{ srcset:_vm.srcset, url:_vm.src, width:_vm.width },"fallback-image":_vm.fallbackImage,"alt":_vm.alt}}),_vm._v(" "),(_vm.withGradient)?_c('div',{staticClass:"gradient-overlay"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }